import { render, staticRenderFns } from "./StudyDatasets.vue?vue&type=template&id=b0f195a0&scoped=true"
import script from "./StudyDatasets.vue?vue&type=script&lang=js"
export * from "./StudyDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f195a0",
  null
  
)

export default component.exports